export default "__VITE_ASSET__Dmc9$y3y__"